/* Harmony Modern - opens any PDF link in an on-site flipbook viewer. */
(function () {
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
  var WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
  var libPromise = null;
  function loadLib() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (libPromise) return libPromise;
    libPromise = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = PDFJS; s.onload = function () { window.pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER; res(window.pdfjsLib); };
      s.onerror = function () { libPromise = null; rej(new Error('lib')); };
      document.head.appendChild(s);
    });
    return libPromise;
  }
  function isPdf(a) {
    if (!a || !a.href || a.hasAttribute('data-no-viewer') || a.hasAttribute('download')) return false;
    try { return /\.pdf$/i.test(new URL(a.href, location.href).pathname); } catch (e) { return false; }
  }
  var state = null;
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }
  function wide() { return window.innerWidth >= 900; }

  function open(url, title) {
    if (state) close();
    var root = el('div', 'pdfv');
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', title || 'Document');
    root.innerHTML =
      '<div class="pdfv__bar"><span class="pdfv__title"></span>' +
      '<a class="pdfv__dl" target="_blank" rel="noopener">Open original</a>' +
      '<button type="button" class="pdfv__close" aria-label="Close">&times;</button></div>' +
      '<div class="pdfv__stage"><div class="pdfv__msg">Opening&hellip;</div>' +
      '<div class="pdfv__book"></div></div>'  +
      '<div class="pdfv__nav"><button type="button" class="pdfv__prev" aria-label="Previous page">&larr;</button>' +
      '<span class="pdfv__count" aria-live="polite"></span>' +
      '<button type="button" class="pdfv__next" aria-label="Next page">&rarr;</button></div>';
    root.querySelector('.pdfv__title').textContent = title || '';
    root.querySelector('.pdfv__dl').href = url;
    document.body.appendChild(root);
    document.documentElement.classList.add('pdfv-open');
    var s = state = { root: root, url: url, doc: null, index: 1, cache: {}, busy: false, lastFocus: document.activeElement };
    root.querySelector('.pdfv__close').addEventListener('click', close);
    root.querySelector('.pdfv__prev').addEventListener('click', function () { go(-1); });
    root.querySelector('.pdfv__next').addEventListener('click', function () { go(1); });
    root.addEventListener('click', function (e) { if (e.target.classList.contains('pdfv__stage')) close(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 60) go(dx < 0 ? 1 : -1);
    }, { passive: true });
    s.resize = function () { clearTimeout(s.resizeTimer); s.resizeTimer = setTimeout(function () { if (state === s) { if (s.busy) s.pendingResize = true; else mount(s); } }, 150); };
    window.addEventListener('resize', s.resize);
    root.querySelector('.pdfv__close').focus();

    loadLib().then(function (lib) { return lib.getDocument(url).promise; }).then(function (doc) {
      if (state !== s) return;
      s.doc = doc; return prepare(s);
    }).catch(function () {
      if (state !== s) return;
      close(); window.open(url, '_blank', 'noopener');
    });
  }
  function close() {
    if (!state) return;
    window.removeEventListener('resize', state.resize);
    clearTimeout(state.resizeTimer);
    if (state.flip) state.flip.destroy();
    if (state.doc) state.doc.destroy();
    var f = state.lastFocus; state.root.remove(); state = null;
    document.documentElement.classList.remove('pdfv-open');
    if (f && f.focus) f.focus();
  }
  function prepare(s) {
    return s.doc.getPage(1).then(function (page) {
      var vp = page.getViewport({ scale: 1 }); s.ratio = vp.width / vp.height;
      s.mapping = window.HarmonyPdfBook.pages(s.doc.numPages); s.pages = [];
      var cursor = 0;
      function worker() {
        var slot = cursor++; if (slot >= s.mapping.length || state !== s) return Promise.resolve();
        var host = el('div', 'pdfv__page'); host.setAttribute('data-density', 'soft'); s.pages[slot] = host;
        var num = s.mapping[slot];
        if (!num) return worker();
        return s.doc.getPage(num).then(function (pdfPage) {
          var original = pdfPage.getViewport({ scale: 1 });
          var viewport = pdfPage.getViewport({ scale: Math.min(1400 / original.height, 2) });
          var canvas = document.createElement('canvas'); canvas.width = Math.round(viewport.width); canvas.height = Math.round(viewport.height);
          return pdfPage.render({ canvasContext: canvas.getContext('2d'), viewport: viewport }).promise.then(function () { host.appendChild(canvas); return worker(); });
        });
      }
      return Promise.all([worker(), worker()]).then(function () { if (state === s) mount(s); });
    });
  }
  function mount(s) {
    if (s.flip) s.flip.destroy();
    var stage = s.root.querySelector('.pdfv__stage'), book = el('div', 'pdfv__book');
    stage.querySelector('.pdfv__book')?.remove(); stage.appendChild(book);
    var portrait = !wide();
    var width = Math.floor(Math.min((stage.clientWidth - 36) / (portrait ? 1 : 2), (stage.clientHeight - 36) * s.ratio));
    var height = Math.floor(width / s.ratio);
    s.pageWidth = width; s.portrait = portrait;
    book.style.width = (width * (portrait ? 1 : 2)) + 'px'; book.style.height = height + 'px';
    book.style.visibility = 'hidden';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    s.flip = new window.St.PageFlip(book, { width: width, height: height, size: 'fixed', showCover: true, usePortrait: portrait,
      autoSize: false, drawShadow: true, maxShadowOpacity: .25, flippingTime: 1100, showPageCorners: false,
      useMouseEvents: false, disableFlipByClick: false, mobileScrollSupport: true, startPage: s.index - 1 });
    s.flip.on('flip', function (e) { s.index = e.data + 1; updateNav(s); });
    s.flip.on('changeState', function (e) {
      s.busy = e.data !== 'read';
      if (!s.busy) { centre(s, s.index - 1, reduced); if (s.pendingResize) { s.pendingResize = false; mount(s); } }
    });
    s.flip.loadFromHTML(s.pages);
    /* showCover controls spreads; soft density makes even the covers bend like paper. */
    s.pages.forEach(function (_, i) {
      var page = s.flip.getPage(i); page.setDensity('soft');
      /* The engine clones soft pages on phones; DOM clones do not copy canvas pixels. */
      var clone = page.newTemporaryCopy.bind(page);
      page.newTemporaryCopy = function () {
        var copy = clone();
        var source = page.getElement().querySelector('canvas');
        var target = copy.getElement().querySelector('canvas');
        if (source && target && source !== target) target.getContext('2d').drawImage(source, 0, 0);
        return copy;
      };
    });
    centre(s, s.flip.getCurrentPageIndex(), true); updateNav(s);
    book.style.visibility = 'visible'; s.root.querySelector('.pdfv__msg').style.display = 'none';
  }
  function centre(s, index, immediate) {
    var view = window.HarmonyPdfBook.view(index, s.mapping, s.portrait);
    var book = s.root.querySelector('.pdfv__book');
    book.style.transition = immediate ? 'none' : 'transform 1100ms cubic-bezier(.4,0,.2,1)';
    book.style.transform = 'translateX(' + (view.offset * s.pageWidth) + 'px)';
  }
  function go(dir) {
    var s = state; if (!s || !s.flip || s.busy) return;
    var index = s.flip.getCurrentPageIndex();
    var view = window.HarmonyPdfBook.view(index, s.mapping, s.portrait);
    if (dir > 0 && view.last || dir < 0 && view.first) return;
    var next = s.portrait ? index + dir : dir > 0 ? (index === 0 ? 1 : index + 2) : (index <= 1 ? 0 : index - 2);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    centre(s, next, reduced);
    if (reduced) s.flip.turnToPage(next);
    else { s.busy = true; if (dir > 0) s.flip.flipNext('bottom'); else s.flip.flipPrev('bottom'); }
  }
  function updateNav(s) {
    var index = s.flip.getCurrentPageIndex();
    var view = window.HarmonyPdfBook.view(index, s.mapping, s.portrait);
    s.root.querySelector('.pdfv__count').textContent = view.numbers.join(' – ') + ' / ' + s.doc.numPages;
    s.root.querySelector('.pdfv__prev').disabled = view.first;
    s.root.querySelector('.pdfv__next').disabled = view.last;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!isPdf(a)) return;
    e.preventDefault();
    open(a.href, (a.getAttribute('data-pdf-title') || a.textContent || '').trim().replace(/\s+/g, ' '));
  });
  document.addEventListener('keydown', function (e) {
    if (!state) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'ArrowLeft') go(-1);
  });
})();
